import WarehouseForm from './WarehouseForm';
export default WarehouseForm;
